// This file is auto-generated by @hey-api/openapi-ts

import {
  formDataBodySerializer,
  type Client,
  type Options as Options2,
  type TDataShape,
} from './client'
import { client } from './client.gen'
import type {
  ArchiveProfileData,
  ArchiveProfileResponses,
  AuthorActionGenerateData,
  AuthorActionGenerateErrors,
  AuthorActionGenerateResponses,
  AuthorActionPossibleKeysData,
  AuthorActionPossibleKeysResponses,
  AuthorActionRationalesData,
  AuthorActionRationalesResponses,
  AuthorActionRegenerateData,
  AuthorActionRegenerateErrors,
  AuthorActionRegenerateResponses,
  AuthorActionSwitcherooData,
  AuthorActionSwitcherooErrors,
  AuthorActionSwitcherooResponses,
  AutosaveItemData,
  AutosaveItemErrors,
  AutosaveItemResponses,
  CheckUnsavedContentData,
  CheckUnsavedContentErrors,
  CheckUnsavedContentResponses,
  CleanupProfilesData,
  CleanupProfilesResponses,
  CloneItemData,
  CloneItemErrors,
  CloneItemResponses,
  CloneItemV2Data,
  CloneItemV2Errors,
  CloneItemV2Responses,
  ContinueExportJobData,
  ContinueExportJobErrors,
  ContinueExportJobResponses,
  CreateAiModelData,
  CreateAiModelErrors,
  CreateAiModelResponses,
  CreateFolderData,
  CreateFolderErrors,
  CreateFolderResponses,
  CreateOrUpdateProfileData,
  CreateOrUpdateProfileErrors,
  CreateOrUpdateProfileResponses,
  CreateUserData,
  CreateUserErrors,
  CreateUserResponses,
  CreateWebhookConfigurationData,
  CreateWebhookConfigurationErrors,
  CreateWebhookConfigurationResponses,
  DeleteAiModelsData,
  DeleteAiModelsResponses,
  DeleteAuth0UsersData,
  DeleteAuth0UsersErrors,
  DeleteAuth0UsersResponses,
  DeleteFinetunesData,
  DeleteFinetunesErrors,
  DeleteFinetunesResponses,
  DeleteFolderData,
  DeleteFolderErrors,
  DeleteFolderResponses,
  DeleteUsersData,
  DeleteUsersErrors,
  DeleteUsersResponses,
  DeleteWebhookConfigurationData,
  DeleteWebhookConfigurationErrors,
  DeleteWebhookConfigurationResponses,
  DiscardDraftData,
  DiscardDraftResponses,
  DismissWorkflowData,
  DismissWorkflowErrors,
  DismissWorkflowResponses,
  DownloadExportedFileData,
  DownloadExportedFileResponses,
  ExportItemsData,
  ExportItemsErrors,
  ExportItemsResponses,
  GenerateData,
  GenerateItemSetData,
  GenerateItemSetResponses,
  GenerateMathData,
  GenerateMathErrors,
  GenerateMathResponses,
  GenerateRationalesData,
  GenerateRationalesResponses,
  GenerateResponses,
  GenerateV2Data,
  GenerateV2Responses,
  GetBatchItemsData,
  GetBatchItemsResponses,
  GetCustomerData,
  GetCustomerResponses,
  GetDraftFolderData,
  GetDraftFolderResponses,
  GetDraftStatsData,
  GetDraftStatsResponses,
  GetEditedItemsData,
  GetEditedItemsResponses,
  GetFeatureFlagDefaultsData,
  GetFeatureFlagDefaultsHistoryData,
  GetFeatureFlagDefaultsHistoryResponses,
  GetFeatureFlagDefaultsResponses,
  GetFolderData,
  GetFolderPermissionsData,
  GetFolderPermissionsErrors,
  GetFolderPermissionsResponses,
  GetFolderResponses,
  GetIntegrationData,
  GetIntegrationErrors,
  GetIntegrationResponses,
  GetItemActivitiesData,
  GetItemActivitiesErrors,
  GetItemActivitiesResponses,
  GetItemByIdentifierData,
  GetItemByIdentifierResponses,
  GetItemMediaData,
  GetItemMediaErrors,
  GetItemMediaListData,
  GetItemMediaListResponses,
  GetItemMediaResponses,
  GetModelPermissionsData,
  GetModelPermissionsResponses,
  GetModelsOverviewData,
  GetModelsOverviewResponses,
  GetProfileByKeyData,
  GetProfileByKeyResponses,
  GetProjectAccessData,
  GetProjectAccessErrors,
  GetProjectAccessResponses,
  GetRecentWorkData,
  GetRecentWorkResponses,
  GetV1ItemData,
  GetV1ItemResponses,
  GetV2ItemData,
  GetV2ItemResponses,
  GetVotedItemsData,
  GetVotedItemsResponses,
  GetWebhookConfigurationData,
  GetWebhookConfigurationErrors,
  GetWebhookConfigurationResponses,
  GetWebhookDeliveryData,
  GetWebhookDeliveryErrors,
  GetWebhookDeliveryResponses,
  HealthzData,
  HealthzResponses,
  ImportExemplarsData,
  ImportExemplarsErrors,
  ImportExemplarsResponses,
  ImportFinetunesData,
  ImportFinetunesErrors,
  ImportFinetunesResponses,
  InternalCreateCustomerData,
  InternalCreateCustomerErrors,
  InternalCreateCustomerResponses,
  InternalGetCustomerData,
  InternalGetCustomerResponses,
  InternalListCustomersData,
  InternalListCustomersResponses,
  InternalUpdateCustomerData,
  InternalUpdateCustomerResponses,
  ListAiModelsData,
  ListAiModelsProfilesAdminData,
  ListAiModelsProfilesAdminResponses,
  ListAiModelsResponses,
  ListCommentsData,
  ListCommentsErrors,
  ListCommentsResponses,
  ListExportJobsData,
  ListExportJobsResponses,
  ListFeedbacksData,
  ListFeedbacksErrors,
  ListFeedbacksResponses,
  ListFoldersBasicData,
  ListFoldersBasicResponses,
  ListFoldersData,
  ListFoldersResponses,
  ListUsersData,
  ListUsersErrors,
  ListUsersResponses,
  ListWebhookConfigurationsData,
  ListWebhookConfigurationsErrors,
  ListWebhookConfigurationsResponses,
  ListWebhookDeliveriesData,
  ListWebhookDeliveriesErrors,
  ListWebhookDeliveriesResponses,
  LoginCallbackData,
  LoginCallbackResponses,
  ModifyVotesData,
  ModifyVotesResponses,
  MoveFolderItemsData,
  MoveFolderItemsResponses,
  PossibleKeysData,
  PossibleKeysErrors,
  PossibleKeysResponses,
  PreValidateExportData,
  PreValidateExportErrors,
  PreValidateExportResponses,
  ProxyWolframImageData,
  ProxyWolframImageResponses,
  QueryWolframData,
  QueryWolframResponses,
  RecentWorkPreferencesData,
  RecentWorkPreferencesErrors,
  RecentWorkPreferencesResponses,
  RemoveFolderItemsData,
  RemoveFolderItemsResponses,
  RenameBatchData,
  RenameBatchErrors,
  RenameBatchResponses,
  RenameFolderData,
  RenameFolderErrors,
  RenameFolderResponses,
  ResetCustomerDataData,
  ResetCustomerDataErrors,
  ResetCustomerDataResponses,
  ResetUserDataData,
  ResetUserDataErrors,
  ResetUserDataResponses,
  RunBiasCheckData,
  RunBiasCheckResponses,
  SaveItemData,
  SaveItemErrors,
  SaveItemResponses,
  SaveItemV2Data,
  SaveItemV2Errors,
  SaveItemV2Responses,
  SearchItemsData,
  SearchItemsResponses,
  SearchReferencesData,
  SearchReferencesErrors,
  SearchReferencesResponses,
  SubmitCommentData,
  SubmitCommentErrors,
  SubmitCommentResponses,
  SubmitFeedbackData,
  SubmitFeedbackErrors,
  SubmitFeedbackResponses,
  SwitchCustomerData,
  SwitchCustomerErrors,
  SwitchCustomerResponses,
  TestIntegrationData,
  TestIntegrationErrors,
  TestIntegrationResponses,
  UnlinkCloneData,
  UnlinkCloneErrors,
  UnlinkCloneResponses,
  UpdateAiModelFlagsData,
  UpdateAiModelFlagsErrors,
  UpdateAiModelFlagsResponses,
  UpdateContentVersionsData,
  UpdateContentVersionsErrors,
  UpdateContentVersionsResponses,
  UpdateFeatureFlagDefaultsData,
  UpdateFeatureFlagDefaultsResponses,
  UpdateFolderData,
  UpdateFolderPermissionsData,
  UpdateFolderPermissionsErrors,
  UpdateFolderPermissionsResponses,
  UpdateFolderResponses,
  UpdateMetadataData,
  UpdateMetadataErrors,
  UpdateMetadataResponses,
  UpdateProfileFlagsData,
  UpdateProfileFlagsErrors,
  UpdateProfileFlagsResponses,
  UpdateUserData,
  UpdateUserErrors,
  UpdateUserLastAccessData,
  UpdateUserLastAccessResponses,
  UpdateUserResponses,
  UpdateWebhookConfigurationData,
  UpdateWebhookConfigurationErrors,
  UpdateWebhookConfigurationResponses,
  UploadMediaToItemData,
  UploadMediaToItemErrors,
  UploadMediaToItemResponses,
  UpsertIntegrationData,
  UpsertIntegrationErrors,
  UpsertIntegrationResponses,
  UpsertModelPermissionsData,
  UpsertModelPermissionsResponses,
  VoteItemData,
  VoteItemResponses,
  WebhookTestConsumerData,
  WebhookTestConsumerResponses,
} from './types.gen'

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

/**
 * Healthz
 */
export const healthz = <ThrowOnError extends boolean = false>(
  options?: Options<HealthzData, ThrowOnError>,
) =>
  (options?.client ?? client).get<HealthzResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/healthz',
    ...options,
  })

/**
 * List Ai Models
 */
export const listAiModels = <ThrowOnError extends boolean = false>(
  options?: Options<ListAiModelsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListAiModelsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/ai-models',
    ...options,
  })

/**
 * Create Ai Model
 */
export const createAiModel = <ThrowOnError extends boolean = false>(
  options: Options<CreateAiModelData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateAiModelResponses, CreateAiModelErrors, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/ai-models',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List Ai Models Profiles Admin
 *
 * Get combined list of AI Models and optionally Profiles for admin permissions management.
 * Returns both entity types in a single list with additional metadata.
 * Profiles are included only if item_types_v2 feature flag is enabled.
 */
export const listAiModelsProfilesAdmin = <ThrowOnError extends boolean = false>(
  options?: Options<ListAiModelsProfilesAdminData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListAiModelsProfilesAdminResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/ai-models/admin',
    ...options,
  })

/**
 * Search References
 */
export const searchReferences = <ThrowOnError extends boolean = false>(
  options: Options<SearchReferencesData, ThrowOnError>,
) =>
  (options.client ?? client).get<SearchReferencesResponses, SearchReferencesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/ai-models/{ai_model_id}/references',
    ...options,
  })

/**
 * Update Ai Model Flags
 */
export const updateAiModelFlags = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAiModelFlagsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UpdateAiModelFlagsResponses,
    UpdateAiModelFlagsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/ai-models/{internal_name}/update-flags',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Model Permissions
 *
 * Get all AI model and profile permissions for the current customer.
 */
export const getModelPermissions = <ThrowOnError extends boolean = false>(
  options?: Options<GetModelPermissionsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetModelPermissionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/ai-models/permissions',
    ...options,
  })

/**
 * Upsert Model Permissions
 *
 * Upsert model permissions for multiple users.
 * Creates new permissions or updates existing ones for either AI models or profiles.
 * Returns updated permissions for affected users.
 */
export const upsertModelPermissions = <ThrowOnError extends boolean = false>(
  options: Options<UpsertModelPermissionsData, ThrowOnError>,
) =>
  (options.client ?? client).post<UpsertModelPermissionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/ai-models/permissions/upsert',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Models Overview
 */
export const getModelsOverview = <ThrowOnError extends boolean = false>(
  options?: Options<GetModelsOverviewData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetModelsOverviewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/author/models-overview',
    ...options,
  })

/**
 * Get Edited Items
 */
export const getEditedItems = <ThrowOnError extends boolean = false>(
  options?: Options<GetEditedItemsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetEditedItemsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/author/edited-items',
    ...options,
  })

/**
 * Get Recent Work
 *
 * Return recent work using CTEs for latest item and content version lookups.
 */
export const getRecentWork = <ThrowOnError extends boolean = false>(
  options?: Options<GetRecentWorkData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetRecentWorkResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/author/recent-work-v2',
    ...options,
  })

/**
 * Recent Work Preferences
 */
export const recentWorkPreferences = <ThrowOnError extends boolean = false>(
  options: Options<RecentWorkPreferencesData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    RecentWorkPreferencesResponses,
    RecentWorkPreferencesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/author/recent-work-preferences',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Author Action Rationales
 */
export const authorActionRationales = <ThrowOnError extends boolean = false>(
  options: Options<AuthorActionRationalesData, ThrowOnError>,
) =>
  (options.client ?? client).post<AuthorActionRationalesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/author/{item_id}/actions/rationales',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Autosave Item
 */
export const autosaveItem = <ThrowOnError extends boolean = false>(
  options: Options<AutosaveItemData, ThrowOnError>,
) =>
  (options.client ?? client).post<AutosaveItemResponses, AutosaveItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/author/{item_id}/actions/autosave',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Discard Draft
 *
 * Discard the latest draft content version for an item, reverting to the saved version.
 * Updates the draft in place with content from the saved version.
 */
export const discardDraft = <ThrowOnError extends boolean = false>(
  options: Options<DiscardDraftData, ThrowOnError>,
) =>
  (options.client ?? client).post<DiscardDraftResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/author/{item_id}/discard-draft',
    ...options,
  })

/**
 * Dismiss Workflow
 *
 * Dismiss an error workflow for an item.
 *
 * Only workflows in error states (FAILED, TIMED_OUT, CANCELLED) can be dismissed.
 */
export const dismissWorkflow = <ThrowOnError extends boolean = false>(
  options: Options<DismissWorkflowData, ThrowOnError>,
) =>
  (options.client ?? client).post<DismissWorkflowResponses, DismissWorkflowErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/author/{item_id}/workflows/{workflow_id}/dismiss',
    ...options,
  })

/**
 * Author Action Generate
 *
 * Trigger generation for an existing item, optionally targeting a specific part.
 *
 * This endpoint supports:
 * - Retry generation for failed items (whole-item retry when part_name is omitted)
 * - Generate specific composite parts (e.g., EBSR Part B)
 * - Optionally specify the item type for the part being generated (part_item_type)
 */
export const authorActionGenerate = <ThrowOnError extends boolean = false>(
  options: Options<AuthorActionGenerateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AuthorActionGenerateResponses,
    AuthorActionGenerateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/author/{item_id}/actions/generate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Author Action Regenerate
 */
export const authorActionRegenerate = <ThrowOnError extends boolean = false>(
  options: Options<AuthorActionRegenerateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AuthorActionRegenerateResponses,
    AuthorActionRegenerateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/author/{item_id}/actions/regenerate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update Metadata
 */
export const updateMetadata = <ThrowOnError extends boolean = false>(
  options: Options<UpdateMetadataData, ThrowOnError>,
) =>
  (options.client ?? client).put<UpdateMetadataResponses, UpdateMetadataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/author/{item_id}/metadata/{metadata_group_internal_name}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Author Action Switcheroo
 *
 * Switch the variant of a given item between X and Y.
 * The item type's on_switcheroo method must be implemented.
 * The frontend should call this after confirming the variant switch with the user.
 */
export const authorActionSwitcheroo = <ThrowOnError extends boolean = false>(
  options: Options<AuthorActionSwitcherooData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AuthorActionSwitcherooResponses,
    AuthorActionSwitcherooErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/author/{item_id}/actions/switcheroo',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get V1 Item
 *
 * Get legacy (v1) item state for frontend polling.
 */
export const getV1Item = <ThrowOnError extends boolean = false>(
  options: Options<GetV1ItemData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetV1ItemResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/author/v1/{item_id}',
    ...options,
  })

/**
 * Get V2 Item
 */
export const getV2Item = <ThrowOnError extends boolean = false>(
  options: Options<GetV2ItemData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetV2ItemResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/author/{identifier}',
    ...options,
  })

/**
 * Author Action Possible Keys
 */
export const authorActionPossibleKeys = <ThrowOnError extends boolean = false>(
  options: Options<AuthorActionPossibleKeysData, ThrowOnError>,
) =>
  (options.client ?? client).post<AuthorActionPossibleKeysResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/author/{item_id}/actions/possible-keys',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Batch Items
 *
 * Retrieve all items associated with a specific batch by batchId.
 */
export const getBatchItems = <ThrowOnError extends boolean = false>(
  options: Options<GetBatchItemsData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetBatchItemsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/author/batch/{batch_id}/items',
    ...options,
  })

/**
 * Rename Batch
 *
 * Rename batch by batch id
 */
export const renameBatch = <ThrowOnError extends boolean = false>(
  options: Options<RenameBatchData, ThrowOnError>,
) =>
  (options.client ?? client).put<RenameBatchResponses, RenameBatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/author/batch/{batch_id}/name',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List Feedbacks
 *
 * List all feedback for an item.
 *
 * Permission: User must have read access to the item.
 */
export const listFeedbacks = <ThrowOnError extends boolean = false>(
  options: Options<ListFeedbacksData, ThrowOnError>,
) =>
  (options.client ?? client).get<ListFeedbacksResponses, ListFeedbacksErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collaboration/items/{identifier}/feedback',
    ...options,
  })

/**
 * Submit Feedback
 *
 * Submit feedback on an item.
 *
 * Permission: User must have read access to the item.
 *
 * Captures a content snapshot from either the draft or saved version
 * depending on the version_type parameter.
 */
export const submitFeedback = <ThrowOnError extends boolean = false>(
  options: Options<SubmitFeedbackData, ThrowOnError>,
) =>
  (options.client ?? client).post<SubmitFeedbackResponses, SubmitFeedbackErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collaboration/items/{identifier}/feedback/submit',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List Comments
 *
 * List all comments for an item.
 *
 * Permission: User must have read access to the item.
 */
export const listComments = <ThrowOnError extends boolean = false>(
  options: Options<ListCommentsData, ThrowOnError>,
) =>
  (options.client ?? client).get<ListCommentsResponses, ListCommentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collaboration/items/{identifier}/comments',
    ...options,
  })

/**
 * Submit Comment
 *
 * Submit a comment on an item.
 *
 * Permission: User must have read access to the item.
 */
export const submitComment = <ThrowOnError extends boolean = false>(
  options: Options<SubmitCommentData, ThrowOnError>,
) =>
  (options.client ?? client).post<SubmitCommentResponses, SubmitCommentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collaboration/items/{identifier}/comments/submit',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List Folders
 */
export const listFolders = <ThrowOnError extends boolean = false>(
  options?: Options<ListFoldersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListFoldersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/folders',
    ...options,
  })

/**
 * Create Folder
 */
export const createFolder = <ThrowOnError extends boolean = false>(
  options: Options<CreateFolderData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateFolderResponses, CreateFolderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/folders',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List Folders Basic
 */
export const listFoldersBasic = <ThrowOnError extends boolean = false>(
  options?: Options<ListFoldersBasicData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListFoldersBasicResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/folders/list-basic',
    ...options,
  })

/**
 * Search Items
 *
 * Search items with the following filters:
 * filter by search term
 * AND filter by type (All, Clone, Internal)
 * AND (filter by domain OR topic OR profile)
 * AND filter by archived=False items
 * AND filter by draft=False items
 *
 * AND WHEN admin
 * filter by selected users (folders/items that at least one of the users has permission)
 * ELSE
 * filter by logged user read models permission
 * filter by logged user read folder permission
 */
export const searchItems = <ThrowOnError extends boolean = false>(
  options?: Options<SearchItemsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<SearchItemsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/folders/list/search',
    ...options,
  })

/**
 * Get Item By Identifier
 */
export const getItemByIdentifier = <ThrowOnError extends boolean = false>(
  options: Options<GetItemByIdentifierData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetItemByIdentifierResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/folders/item-by-identifier/{identifier}',
    ...options,
  })

/**
 * Pre Validate Export
 */
export const preValidateExport = <ThrowOnError extends boolean = false>(
  options: Options<PreValidateExportData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PreValidateExportResponses,
    PreValidateExportErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/folders/pre-validate-export',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Folder Permissions
 */
export const getFolderPermissions = <ThrowOnError extends boolean = false>(
  options: Options<GetFolderPermissionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetFolderPermissionsResponses,
    GetFolderPermissionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/folders/{folder_id}/permissions',
    ...options,
  })

/**
 * Update Folder Permissions
 */
export const updateFolderPermissions = <ThrowOnError extends boolean = false>(
  options: Options<UpdateFolderPermissionsData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateFolderPermissionsResponses,
    UpdateFolderPermissionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/folders/{folder_id}/permissions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Draft Folder
 */
export const getDraftFolder = <ThrowOnError extends boolean = false>(
  options?: Options<GetDraftFolderData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetDraftFolderResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/folders/draft-items',
    ...options,
  })

/**
 * Get Draft Stats
 */
export const getDraftStats = <ThrowOnError extends boolean = false>(
  options?: Options<GetDraftStatsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetDraftStatsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/folders/draft-items/stats',
    ...options,
  })

/**
 * Move Folder Items
 */
export const moveFolderItems = <ThrowOnError extends boolean = false>(
  options: Options<MoveFolderItemsData, ThrowOnError>,
) =>
  (options.client ?? client).post<MoveFolderItemsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/folders/move-folder-items',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Remove Folder Items
 */
export const removeFolderItems = <ThrowOnError extends boolean = false>(
  options: Options<RemoveFolderItemsData, ThrowOnError>,
) =>
  (options.client ?? client).post<RemoveFolderItemsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/folders/remove-folder-items',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete Folder
 */
export const deleteFolder = <ThrowOnError extends boolean = false>(
  options: Options<DeleteFolderData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteFolderResponses, DeleteFolderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/folders/{folder_id}',
    ...options,
  })

/**
 * Get Folder
 */
export const getFolder = <ThrowOnError extends boolean = false>(
  options: Options<GetFolderData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetFolderResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/folders/{folder_id}',
    ...options,
  })

/**
 * Update Folder
 *
 * Move and/or rename given folder
 */
export const updateFolder = <ThrowOnError extends boolean = false>(
  options: Options<UpdateFolderData, ThrowOnError>,
) =>
  (options.client ?? client).put<UpdateFolderResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/folders/{folder_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Rename Folder
 */
export const renameFolder = <ThrowOnError extends boolean = false>(
  options: Options<RenameFolderData, ThrowOnError>,
) =>
  (options.client ?? client).put<RenameFolderResponses, RenameFolderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/folders/{folder_id}/name',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Customer
 */
export const getCustomer = <ThrowOnError extends boolean = false>(
  options?: Options<GetCustomerData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetCustomerResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/customer',
    ...options,
  })

/**
 * Continue Export Job
 */
export const continueExportJob = <ThrowOnError extends boolean = false>(
  options: Options<ContinueExportJobData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ContinueExportJobResponses,
    ContinueExportJobErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/exports/{export_id}/continue',
    ...options,
  })

/**
 * Download Exported File
 */
export const downloadExportedFile = <ThrowOnError extends boolean = false>(
  options: Options<DownloadExportedFileData, ThrowOnError>,
) =>
  (options.client ?? client).get<DownloadExportedFileResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/exports/{export_id}/download',
    ...options,
  })

/**
 * List Export Jobs
 */
export const listExportJobs = <ThrowOnError extends boolean = false>(
  options: Options<ListExportJobsData, ThrowOnError>,
) =>
  (options.client ?? client).get<ListExportJobsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/exports',
    ...options,
  })

/**
 * Export Items
 */
export const exportItems = <ThrowOnError extends boolean = false>(
  options: Options<ExportItemsData, ThrowOnError>,
) =>
  (options.client ?? client).post<ExportItemsResponses, ExportItemsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/exports',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete Finetunes
 */
export const deleteFinetunes = <ThrowOnError extends boolean = false>(
  options: Options<DeleteFinetunesData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteFinetunesResponses, DeleteFinetunesErrors, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/finetunes/{parent_name}',
    ...options,
  })

/**
 * Import Finetunes
 */
export const importFinetunes = <ThrowOnError extends boolean = false>(
  options: Options<ImportFinetunesData, ThrowOnError>,
) =>
  (options.client ?? client).post<ImportFinetunesResponses, ImportFinetunesErrors, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/finetunes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Integration
 */
export const getIntegration = <ThrowOnError extends boolean = false>(
  options: Options<GetIntegrationData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetIntegrationResponses, GetIntegrationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/internal/integrations/{integration_type}',
    ...options,
  })

/**
 * Upsert Integration
 */
export const upsertIntegration = <ThrowOnError extends boolean = false>(
  options: Options<UpsertIntegrationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UpsertIntegrationResponses,
    UpsertIntegrationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/internal/integrations/{integration_type}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Test Integration
 */
export const testIntegration = <ThrowOnError extends boolean = false>(
  options: Options<TestIntegrationData, ThrowOnError>,
) =>
  (options.client ?? client).post<TestIntegrationResponses, TestIntegrationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/internal/integrations/{integration_type}/test',
    ...options,
  })

/**
 * Delete Auth0 Users
 */
export const deleteAuth0Users = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAuth0UsersData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAuth0UsersResponses,
    DeleteAuth0UsersErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/internal/gdpr_users',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Internal Create Customer
 */
export const internalCreateCustomer = <ThrowOnError extends boolean = false>(
  options: Options<InternalCreateCustomerData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    InternalCreateCustomerResponses,
    InternalCreateCustomerErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/internal/customers',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Internal List Customers
 */
export const internalListCustomers = <ThrowOnError extends boolean = false>(
  options?: Options<InternalListCustomersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<InternalListCustomersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/internal/customers/internal_list_customers',
    ...options,
  })

/**
 * Delete Ai Models
 */
export const deleteAiModels = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAiModelsData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteAiModelsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/internal/customers/{customer_name}/ai-models',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Internal Get Customer
 */
export const internalGetCustomer = <ThrowOnError extends boolean = false>(
  options?: Options<InternalGetCustomerData, ThrowOnError>,
) =>
  (options?.client ?? client).get<InternalGetCustomerResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/internal/customers/self',
    ...options,
  })

/**
 * Internal Update Customer
 */
export const internalUpdateCustomer = <ThrowOnError extends boolean = false>(
  options: Options<InternalUpdateCustomerData, ThrowOnError>,
) =>
  (options.client ?? client).post<InternalUpdateCustomerResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/internal/customers/self',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Feature Flag Defaults
 */
export const getFeatureFlagDefaults = <ThrowOnError extends boolean = false>(
  options?: Options<GetFeatureFlagDefaultsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetFeatureFlagDefaultsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/internal/feature-flag-defaults',
    ...options,
  })

/**
 * Update Feature Flag Defaults
 */
export const updateFeatureFlagDefaults = <ThrowOnError extends boolean = false>(
  options: Options<UpdateFeatureFlagDefaultsData, ThrowOnError>,
) =>
  (options.client ?? client).post<UpdateFeatureFlagDefaultsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/internal/feature-flag-defaults',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Feature Flag Defaults History
 */
export const getFeatureFlagDefaultsHistory = <ThrowOnError extends boolean = false>(
  options?: Options<GetFeatureFlagDefaultsHistoryData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetFeatureFlagDefaultsHistoryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/internal/feature-flag-defaults/history',
    ...options,
  })

/**
 * Switch Customer
 */
export const switchCustomer = <ThrowOnError extends boolean = false>(
  options: Options<SwitchCustomerData, ThrowOnError>,
) =>
  (options.client ?? client).post<SwitchCustomerResponses, SwitchCustomerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/internal/switch-customers/{customer_id}',
    ...options,
  })

/**
 * Reset Customer Data
 */
export const resetCustomerData = <ThrowOnError extends boolean = false>(
  options?: Options<ResetCustomerDataData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    ResetCustomerDataResponses,
    ResetCustomerDataErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/internal/reset-customer-data',
    ...options,
  })

/**
 * Reset User Data
 */
export const resetUserData = <ThrowOnError extends boolean = false>(
  options?: Options<ResetUserDataData, ThrowOnError>,
) =>
  (options?.client ?? client).post<ResetUserDataResponses, ResetUserDataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/internal/reset-user-data',
    ...options,
  })

/**
 * Cleanup Profiles
 *
 * Internal endpoint to cleanup all profiles, exemplars, and their items.
 * Can only run in local, dev, qa environments.
 * Requires API key authentication.
 */
export const cleanupProfiles = <ThrowOnError extends boolean = false>(
  options?: Options<CleanupProfilesData, ThrowOnError>,
) =>
  (options?.client ?? client).delete<CleanupProfilesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/internal/cleanup/profiles',
    ...options,
  })

/**
 * Generate Item Set
 */
export const generateItemSet = <ThrowOnError extends boolean = false>(
  options: Options<GenerateItemSetData, ThrowOnError>,
) =>
  (options.client ?? client).post<GenerateItemSetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/item-sets',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Generate
 */
export const generate = <ThrowOnError extends boolean = false>(
  options: Options<GenerateData, ThrowOnError>,
) =>
  (options.client ?? client).post<GenerateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/items',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Item Activities
 */
export const getItemActivities = <ThrowOnError extends boolean = false>(
  options: Options<GetItemActivitiesData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetItemActivitiesResponses, GetItemActivitiesErrors, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/items/{item_id}/activities',
      ...options,
    },
  )

/**
 * Get Item Media List
 */
export const getItemMediaList = <ThrowOnError extends boolean = false>(
  options: Options<GetItemMediaListData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetItemMediaListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/items/{item_id}/media',
    ...options,
  })

/**
 * Upload Media To Item
 */
export const uploadMediaToItem = <ThrowOnError extends boolean = false>(
  options: Options<UploadMediaToItemData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UploadMediaToItemResponses,
    UploadMediaToItemErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/items/{item_id}/media',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  })

/**
 * Get Item Media
 */
export const getItemMedia = <ThrowOnError extends boolean = false>(
  options: Options<GetItemMediaData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetItemMediaResponses, GetItemMediaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/items/{item_id}/media/{media_id}',
    ...options,
  })

/**
 * Check Unsaved Content
 */
export const checkUnsavedContent = <ThrowOnError extends boolean = false>(
  options: Options<CheckUnsavedContentData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    CheckUnsavedContentResponses,
    CheckUnsavedContentErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/items/{item_id}/check-unsaved-content',
    ...options,
  })

/**
 * Update Content Versions
 */
export const updateContentVersions = <ThrowOnError extends boolean = false>(
  options: Options<UpdateContentVersionsData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdateContentVersionsResponses,
    UpdateContentVersionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/items/{item_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Save Item V2
 */
export const saveItemV2 = <ThrowOnError extends boolean = false>(
  options: Options<SaveItemV2Data, ThrowOnError>,
) =>
  (options.client ?? client).post<SaveItemV2Responses, SaveItemV2Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/items/v2/{item_id}/save',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Clone Item V2
 *
 * Clone a v2 item (MCQ, EBSR, etc.).
 * If the user owns the batch, adds the cloned item to the existing batch.
 * If the user doesn't own the batch, creates a new batch owned by the user.
 */
export const cloneItemV2 = <ThrowOnError extends boolean = false>(
  options: Options<CloneItemV2Data, ThrowOnError>,
) =>
  (options.client ?? client).post<CloneItemV2Responses, CloneItemV2Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/items/v2/{item_id}/clone',
    ...options,
  })

/**
 * Unlink Clone
 *
 * Remove the cloned_from reference from an item.
 * Requires write permission to the item/profile/ai_model.
 */
export const unlinkClone = <ThrowOnError extends boolean = false>(
  options: Options<UnlinkCloneData, ThrowOnError>,
) =>
  (options.client ?? client).patch<UnlinkCloneResponses, UnlinkCloneErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/items/{item_id}/unlink-clone',
    ...options,
  })

/**
 * Run Bias Check
 */
export const runBiasCheck = <ThrowOnError extends boolean = false>(
  options: Options<RunBiasCheckData, ThrowOnError>,
) =>
  (options.client ?? client).post<RunBiasCheckResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/items/{item_id}/bias-check',
    ...options,
  })

/**
 * Save Item
 */
export const saveItem = <ThrowOnError extends boolean = false>(
  options: Options<SaveItemData, ThrowOnError>,
) =>
  (options.client ?? client).post<SaveItemResponses, SaveItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/items/{item_id}/save',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Vote Item
 */
export const voteItem = <ThrowOnError extends boolean = false>(
  options: Options<VoteItemData, ThrowOnError>,
) =>
  (options.client ?? client).post<VoteItemResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/items/{item_id}/vote',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Generate Math
 */
export const generateMath = <ThrowOnError extends boolean = false>(
  options: Options<GenerateMathData, ThrowOnError>,
) =>
  (options.client ?? client).post<GenerateMathResponses, GenerateMathErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/items/{item_id}/generate-math',
    ...options,
  })

/**
 * Generate Rationales
 */
export const generateRationales = <ThrowOnError extends boolean = false>(
  options: Options<GenerateRationalesData, ThrowOnError>,
) =>
  (options.client ?? client).post<GenerateRationalesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/items/{item_id}/rationales',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Possible Keys
 */
export const possibleKeys = <ThrowOnError extends boolean = false>(
  options: Options<PossibleKeysData, ThrowOnError>,
) =>
  (options.client ?? client).post<PossibleKeysResponses, PossibleKeysErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/items/{item_id}/possible-keys',
    ...options,
  })

/**
 * Clone Item
 */
export const cloneItem = <ThrowOnError extends boolean = false>(
  options: Options<CloneItemData, ThrowOnError>,
) =>
  (options.client ?? client).post<CloneItemResponses, CloneItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/items/{item_id}/clone',
    ...options,
  })

/**
 * Login Callback
 */
export const loginCallback = <ThrowOnError extends boolean = false>(
  options?: Options<LoginCallbackData, ThrowOnError>,
) =>
  (options?.client ?? client).get<LoginCallbackResponses, unknown, ThrowOnError>({
    url: '/api/login-callback',
    ...options,
  })

/**
 * Update User Last Access
 */
export const updateUserLastAccess = <ThrowOnError extends boolean = false>(
  options?: Options<UpdateUserLastAccessData, ThrowOnError>,
) =>
  (options?.client ?? client).patch<UpdateUserLastAccessResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/update-last-access',
    ...options,
  })

/**
 * Delete Users
 */
export const deleteUsers = <ThrowOnError extends boolean = false>(
  options: Options<DeleteUsersData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteUsersResponses, DeleteUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List Users
 *
 * Fetch all users in customer with aggregated model and profile permissions.
 * Excludes current user from results and respects tenant isolation.
 */
export const listUsers = <ThrowOnError extends boolean = false>(
  options?: Options<ListUsersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListUsersResponses, ListUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users',
    ...options,
  })

/**
 * Create User
 */
export const createUser = <ThrowOnError extends boolean = false>(
  options: Options<CreateUserData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateUserResponses, CreateUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update User
 */
export const updateUser = <ThrowOnError extends boolean = false>(
  options: Options<UpdateUserData, ThrowOnError>,
) =>
  (options.client ?? client).patch<UpdateUserResponses, UpdateUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/{user_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Project Access
 *
 * Fetch project access statistics per user for the customer.
 * Only counts projects with can_deliver=True.
 * Returns project access data for all users in the current customer.
 */
export const getProjectAccess = <ThrowOnError extends boolean = false>(
  options?: Options<GetProjectAccessData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetProjectAccessResponses, GetProjectAccessErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users-project-access',
    ...options,
  })

/**
 * List Webhook Configurations
 */
export const listWebhookConfigurations = <ThrowOnError extends boolean = false>(
  options?: Options<ListWebhookConfigurationsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListWebhookConfigurationsResponses,
    ListWebhookConfigurationsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/webhooks/configurations',
    ...options,
  })

/**
 * Create Webhook Configuration
 */
export const createWebhookConfiguration = <ThrowOnError extends boolean = false>(
  options: Options<CreateWebhookConfigurationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateWebhookConfigurationResponses,
    CreateWebhookConfigurationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/webhooks/configurations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete Webhook Configuration
 */
export const deleteWebhookConfiguration = <ThrowOnError extends boolean = false>(
  options: Options<DeleteWebhookConfigurationData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteWebhookConfigurationResponses,
    DeleteWebhookConfigurationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/webhooks/configurations/{config_id}',
    ...options,
  })

/**
 * Get Webhook Configuration
 */
export const getWebhookConfiguration = <ThrowOnError extends boolean = false>(
  options: Options<GetWebhookConfigurationData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetWebhookConfigurationResponses,
    GetWebhookConfigurationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/webhooks/configurations/{config_id}',
    ...options,
  })

/**
 * Update Webhook Configuration
 */
export const updateWebhookConfiguration = <ThrowOnError extends boolean = false>(
  options: Options<UpdateWebhookConfigurationData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateWebhookConfigurationResponses,
    UpdateWebhookConfigurationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/webhooks/configurations/{config_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Webhook Delivery
 */
export const getWebhookDelivery = <ThrowOnError extends boolean = false>(
  options: Options<GetWebhookDeliveryData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetWebhookDeliveryResponses,
    GetWebhookDeliveryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/webhooks/deliveries/{delivery_id}',
    ...options,
  })

/**
 * List Webhook Deliveries
 */
export const listWebhookDeliveries = <ThrowOnError extends boolean = false>(
  options?: Options<ListWebhookDeliveriesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListWebhookDeliveriesResponses,
    ListWebhookDeliveriesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/webhooks/deliveries',
    ...options,
  })

/**
 * Webhook Test Consumer
 *
 * Test endpoint for consuming webhook deliveries.
 *
 * This endpoint simulates an external webhook receiver for testing purposes.
 * It validates the expected payload structure and logs the received data.
 *
 * Use this endpoint to test webhook delivery without needing an external service.
 * Set webhook_url to: http://localhost:8000/api/webhooks/consumer?internal=true
 * the webhook_config will add the customer_id automatically when internal=true.
 *
 * Query parameters for error simulation:
 * - error_code: specific HTTP status code to return (default: 400 for client, 500 for server)
 *
 * Returns 200 on success, 400/500 on simulated errors, 401 on missing authorization.
 */
export const webhookTestConsumer = <ThrowOnError extends boolean = false>(
  options: Options<WebhookTestConsumerData, ThrowOnError>,
) =>
  (options.client ?? client).post<WebhookTestConsumerResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/webhooks/consumer',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Voted Items
 */
export const getVotedItems = <ThrowOnError extends boolean = false>(
  options?: Options<GetVotedItemsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetVotedItemsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/voted-items',
    ...options,
  })

/**
 * Modify Votes
 */
export const modifyVotes = <ThrowOnError extends boolean = false>(
  options: Options<ModifyVotesData, ThrowOnError>,
) =>
  (options.client ?? client).post<ModifyVotesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/voted-items/votes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Query Wolfram
 */
export const queryWolfram = <ThrowOnError extends boolean = false>(
  options: Options<QueryWolframData, ThrowOnError>,
) =>
  (options.client ?? client).get<QueryWolframResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/wolfram',
    ...options,
  })

/**
 * Proxy Wolfram Image
 */
export const proxyWolframImage = <ThrowOnError extends boolean = false>(
  options: Options<ProxyWolframImageData, ThrowOnError>,
) =>
  (options.client ?? client).get<ProxyWolframImageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/wolfram/proxy',
    ...options,
  })

/**
 * Import Exemplars
 */
export const importExemplars = <ThrowOnError extends boolean = false>(
  options: Options<ImportExemplarsData, ThrowOnError>,
) =>
  (options.client ?? client).post<ImportExemplarsResponses, ImportExemplarsErrors, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/ai/exemplar/import',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Archive Profile
 */
export const archiveProfile = <ThrowOnError extends boolean = false>(
  options: Options<ArchiveProfileData, ThrowOnError>,
) =>
  (options.client ?? client).delete<ArchiveProfileResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/ai/profile/{profile_key}',
    ...options,
  })

/**
 * Get Profile By Key
 */
export const getProfileByKey = <ThrowOnError extends boolean = false>(
  options: Options<GetProfileByKeyData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetProfileByKeyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/ai/profile/{profile_key}',
    ...options,
  })

/**
 * Create Or Update Profile
 *
 * Create a new profile or update existing one.
 *
 * The profile_key must be unique within the customer context.
 */
export const createOrUpdateProfile = <ThrowOnError extends boolean = false>(
  options: Options<CreateOrUpdateProfileData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateOrUpdateProfileResponses,
    CreateOrUpdateProfileErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/ai/profile',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update Profile Flags
 *
 * Update feature flags for a profile.
 */
export const updateProfileFlags = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProfileFlagsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UpdateProfileFlagsResponses,
    UpdateProfileFlagsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/ai/profile/{profile_key}/update-flags',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Generate V2
 */
export const generateV2 = <ThrowOnError extends boolean = false>(
  options: Options<GenerateV2Data, ThrowOnError>,
) =>
  (options.client ?? client).post<GenerateV2Responses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/ai/generate-v2',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
